<script>
	import { setContext } from 'svelte'
	import { writable } from 'svelte/store'
	export let initialStep = 1;
	export let currentStep;

	let step = writable(initialStep);
	let numSteps = writable(0);

	$: currentStep = $step;

	export const goTo = s => {
		$step = s >= 0 ? s : 0;

		if ('scrollBehavior' in document.documentElement.style) {
			window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
		} else {
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
		}
	}
	export const nextStep = () => goTo($step + 1);
	export const previousStep = () => goTo($step - 1);

	setContext('StepWizard', {
		step,
		numSteps,
		goTo,
		nextStep,
		previousStep
	})
</script>

<slot {nextStep} {previousStep} currentStep={$step} numSteps={$numSteps}></slot>
